import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import "./MobileOtpPage.css";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import callApi from "../../../../utility/apiCaller";
import { setUserClickData } from "../../../../utility/setUserClickData";
import { login } from "../../../../store/app/appReducer";
import OTPInput from "react-otp-input";
import FormInputStyle2 from "../../../../components/Form/FormInputStyle2";
import FormButtonStyleCheckOffer from "../../../../components/Form/FormButtonStyleCheckOffer";
// import moment from "moment"; // not used after campaign flow change
// import { setInternalLead } from "../../../../store/app/aaSlice"; // only used by generateLead (commented out below)
const MobileOtpPage = ({
  isFormStarted,
  setIsFormStarted,
  currentStep,
  setCurrentStep,
  formData,
  setFormData,
}) => {
  const [mobile, setMobile] = useState("");
  const [isMobileValid, setIsMobileValid] = useState(true);
  const [source, setSource] = useState("");
  const [utmSource, setUtmSource] = useState("");
  const [utmMedium, setUtmMedium] = useState("");
  const [affId, setAffId] = useState("");
  const [params] = useSearchParams();
  const [isConsentChecked, setIsConsentChecked] = useState(true); // ✅ default true
  const [isPrefrConsentChecked, setIsPrefrConsentChecked] = useState(true);
  const [isLoading, setIsLoading] = useState(false);
  const [isTncChecked, setIsTncChecked] = useState(true);
  const [isOtpGenerated, setIsOtpGenerated] = useState(false);
  const [otp, setOtp] = useState("");
  const dispatch = useDispatch();
  const [leadId, setLeadId] = useState("");
  const [isEditMobileModalOpen, setIsEditMobileModalOpen] = useState(false);
  const [editMobileValue, setEditMobileValue] = useState("");
  const [editMobileError, setEditMobileError] = useState("");
  const RESEND_OTP_TIME = 30;
  const [resendCounter, setResendCounter] = useState(RESEND_OTP_TIME);
  const [canResendOtp, setCanResendOtp] = useState(false);
  const [otpTimerKey, setOtpTimerKey] = useState(0);
  const [ipAddress, setIpAddress] = useState("");
  const ldId = params.get("ld_id") || "";

  // ✅ lender_id from params
  const pre_lender_id = params.get("lender_id") || "";

  // Fetch IP
  useEffect(() => {
    const fetchIp = async () => {
      try {
        const res = await fetch("https://api.ipify.org?format=json");
        const data = await res.json();
        setIpAddress(data?.ip);
      } catch (error) {
        console.log("Error fetching IP:", error);
      }
    };
    fetchIp();
  }, []);

  // OTP Timer
  useEffect(() => {
    if (!isOtpGenerated) return;

    setResendCounter(RESEND_OTP_TIME);
    setCanResendOtp(false);

    const interval = setInterval(() => {
      setResendCounter((prev) => {
        if (prev <= 1) {
          clearInterval(interval);
          setCanResendOtp(true);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(interval);
  }, [isOtpGenerated, otpTimerKey]);

  // URL Params
  useEffect(() => {
    if (params.get("source")) setSource(params.get("source"));
    if (params.get("utm_source")) setUtmSource(params.get("utm_source"));
    if (params.get("utm_medium")) setUtmMedium(params.get("utm_medium"));
    if (params.get("aff_id")) setAffId(params.get("aff_id"));
    if (params.get("lid")) setLeadId(params.get("lid"));
  }, [params]);

  // Reset OTP
  useEffect(() => {
    const container = document.getElementById("personal-loan-form");
    if (container) {
      container.resetOtpState = () => {
        setIsOtpGenerated(false);
        setOtp("");
      };
    }
  }, []);

  const formatResendTime = (seconds) => {
    const clamped = Math.max(0, Number(seconds) || 0);
    const mm = String(Math.floor(clamped / 60)).padStart(2, "0");
    const ss = String(clamped % 60).padStart(2, "0");
    return `${mm}:${ss}`;
  };

  const handleMobileChange = (event) => {
    const value = event.target.value;
    if (/^\d*$/.test(value)) {
      setMobile(value);
      setFormData((prev) => ({ ...prev, mobile: value }));
    }
    setIsMobileValid(value.length === 10);
  };

  const handleConsentChange = () => {
    setIsConsentChecked((prev) => !prev);
  };

  const handlePrefrConsentChange = () => {
    setIsPrefrConsentChecked((prev) => !prev);
  };

  const handleValidation = () => {
    if (!/^\d{10}$/.test(mobile) || mobile.length !== 10) {
      setIsMobileValid(false);
      return false;
    }
    setIsMobileValid(true);
    return true;
  };

  // ─────────────────────────────────────────────────────────────
  // generateLead: commented out for existing-users campaign flow.
  // We no longer create new leads here — if mobile isn't found in DB,
  // user gets redirected to https://digitmoney.in/personal-loan-v13.
  // Uncomment + restore imports (moment, setInternalLead) if needed again.
  // ─────────────────────────────────────────────────────────────
  // const generateLead = async (token) => {
  //   try {
  //     const res = await callApi(
  //       "v1/lead/dmi-lead",
  //       "post",
  //       {
  //         lead: {
  //           contact_phone: mobile,
  //           contact_name: "N/A",
  //           steps_completed: 1,
  //           alliance_id: "prefr-v1-lead",
  //           aff_id: params.get("aff_id") || null,
  //           utm_source: params.get("utm_source") || null,
  //           source: params.get("source") || null,
  //           utm_medium: params.get("utm_medium") || null,
  //           utm_term: params.get("utm_term") || null,
  //           ads_name: params.get("ads_name") || null,
  //           ip_address: ipAddress,
  //           kyc_consent: isTncChecked,
  //           kyc_consent_datetime: new Date().toISOString(),
  //           prefr_kyc_consent: isPrefrConsentChecked,
  //         },
  //       },
  //       "core",
  //       token,
  //     );
  //
  //     if (!res || res.status !== "Success") {
  //       console.error("DMI Lead API failed:", res);
  //       toast.error("Unable to create lead at the moment.");
  //       return false;
  //     }
  //
  //     const finalLeadId = res?.data?.lead?._id;
  //
  //     if (!finalLeadId) {
  //       console.error("Lead ID missing in response:", res);
  //       toast.error("Lead creation failed due to invalid response.");
  //       return false;
  //     }
  //
  //     dispatch(setInternalLead(finalLeadId));
  //     return finalLeadId;
  //   } catch (error) {
  //     console.error("Unexpected error in generateLead:", error);
  //     toast.error("Something went wrong while generating lead.");
  //     return false;
  //   }
  // };

  const fetchLeadData = async (token) => {
    try {
      if (leadId) return { hasLead: false, hasOffer: false };

      const response = await callApi(
        "v1/lead/list",
        "post",
        {
          filters: {
            contact_phone: mobile,
          },
        },
        "core",
      );

      const sortedLeads = (response?.data?.leadList || []).sort(
        (a, b) =>
          new Date(b.updatedAt || b.createdAt) -
          new Date(a.updatedAt || a.createdAt),
      );

      const lead = sortedLeads[0];

      if (lead) {
        const { _id, steps_completed } = lead;
        console.log("Existing lead found:", _id, "steps_completed:", steps_completed);
        return { hasLead: true, hasOffer: false, leadId: _id };
      }

      // No existing lead found for this campaign user
      console.log("No existing lead found for mobile:", mobile);
      return { hasLead: false, hasOffer: false, leadId: null };
    } catch (error) {
      console.error("Failed to fetch lead data:", error);
      return { hasLead: false, hasOffer: false, leadId: null };
    }
  };

  const handleSendOtp = async () => {
    if (!handleValidation()) return;
    if (!isConsentChecked) {
      toast.error("Please agree to the Terms and Conditions.");
      return;
    }

    try {
      setIsLoading(true);
      const response = await callApi(
        "v1/sms/send-otp",
        "post",
        {
          contact_phone: mobile,
          kyc_consent: isConsentChecked,
          prefr_kyc_consent: isPrefrConsentChecked,
        },
        "messaging",
      );

      if (response.status === "Success") {
        setUserClickData({
          event_name: `otp-send-for-prefr-v1-lead`,
          user_id: mobile || "unknown",
          affiliate_id: affId || "No Aff_id found",
          utm_medium: utmMedium || "",
        });
        setFormData((prev) => ({
          ...prev,
          mobile,
          mobiletncchecked: true,
          mobiletnctime: new Date().toISOString(),
          stepDone: 3,
        }));
        //toast.success("OTP Sent Successfully");
        setIsOtpGenerated(true);
        setIsFormStarted();
        setOtpTimerKey((prev) => prev + 1);
      } else {
        toast.error("Failed to send OTP. Please try again.");
      }
    } catch (error) {
      toast.error("An error occurred while sending OTP.");
    } finally {
      setIsLoading(false);
    }
  };

  const openEditMobileModal = () => {
    setEditMobileValue(mobile || "");
    setEditMobileError("");
    setIsEditMobileModalOpen(true);
  };

  const closeEditMobileModal = () => {
    setIsEditMobileModalOpen(false);
    setEditMobileError("");
  };

  // ✅ handleEditMobileSendOtp added
  const handleEditMobileSendOtp = async () => {
    const nextMobile = String(editMobileValue || "").trim();
    if (!/^\d{10}$/.test(nextMobile)) {
      setEditMobileError("Please enter a valid Mobile Number");
      return;
    }
    try {
      setIsLoading(true);
      const response = await callApi(
        "v1/sms/send-otp",
        "post",
        {
          contact_phone: nextMobile,
          kyc_consent: isConsentChecked,
          prefr_kyc_consent: isPrefrConsentChecked,
        },
        "messaging",
      );
      if (response.status === "Success") {
        setMobile(nextMobile);
        setFormData((prev) => ({ ...prev, mobile: nextMobile }));
        setOtp("");
        setIsOtpGenerated(true);
        setOtpTimerKey((prev) => prev + 1);
        closeEditMobileModal();
        //toast.success("OTP Sent Successfully");
      } else {
        toast.error("Failed to send OTP. Please try again.");
      }
    } catch (error) {
      toast.error("An error occurred while sending OTP.");
    } finally {
      setIsLoading(false);
    }
  };

  const handleResendOtp = async () => {
    if (!canResendOtp) return;
    try {
      setIsLoading(true);
      const response = await callApi(
        "v1/sms/send-otp",
        "post",
        {
          contact_phone: mobile,
          kyc_consent: isConsentChecked,
          kyc_consent_datetime: new Date().toISOString(),
          prefr_kyc_consent: isPrefrConsentChecked,
          website_kyc_consent: isTncChecked,
          website_kyc_consent_datetime: new Date().toISOString(),
        },
        "messaging",
      );
      if (response.status === "Success") {
        setUserClickData({
          event_name: `resend-otp-form-for-prefr-v1-lead`,
          user_id: mobile || "unknown",
          affiliate_id: affId || "No Aff_id found",
        });
        //toast.success("OTP Resent Successfully");
        setOtpTimerKey((prev) => prev + 1);
      } else {
        toast.error("Failed to resend OTP.");
      }
    } catch (error) {
      console.error(error);
      toast.error("An error occurred while resending OTP.");
    } finally {
      setIsLoading(false);
    }
  };

  const handleOtpSubmit = async () => {
    if (otp.length !== 4) {
      toast.error("Please enter a valid 4-digit OTP.");
      return;
    }

    try {
      setIsLoading(true);

      // Step 1: OTP Validate
      const otpResponse = await callApi(
        "v1/sms/validate-otp",
        "post",
        { contact_phone: mobile, otp },
        "messaging",
      );

      if (otpResponse.status === "Success") {
        setUserClickData({
          event_name: `verify-otp-prefr-v1-lead`,
          user_id: mobile || "unknown",
          affiliate_id: affId || "No Aff_id found",
          utm_source: utmSource || "",
          utm_medium: utmMedium || "",
        });
        //toast.success("OTP Verified Successfully");
        const leadData = await fetchLeadData(otpResponse?.data.token);
        console.log("leadData: ", leadData);

        // ✅ Existing-users campaign: if no lead in DB, redirect to public landing page
        if (!leadData?.hasLead) {
          toast.info("Redirecting...");
          window.location.href = "https://digitmoney.in/personal-loan-v13?aff_id=49&utm_term=PrefrCampaign&utm_medium=SMS";
          return;
        }

        // Step 2: Login
        dispatch(
          login({
            ...otpResponse.data.customer,
            token: otpResponse.data.token,
          }),
        );
        localStorage.setItem("mobile", mobile);

        // Step 3: Lead fetch/insert
        const leadResponse = await callApi(
          "v1/lead/lead-from-phone",
          "post",
          {
          phone: mobile,
          website_kyc_consent: isTncChecked,
          website_kyc_consent_datetime: new Date().toISOString(),
          kyc_consent: isTncChecked,
          kyc_consent_datetime: new Date().toISOString(),
          prefr_kyc_consent: isPrefrConsentChecked,
          utm_medium: utmMedium,
          otp_page: "prefr-v1-lead",
          ip_address: ipAddress,
          aff_id: affId
        },
          "core",
          otpResponse.data.token,
        );

        const fetchedLeadId = leadResponse?.data?.lead?._id;

        if (fetchedLeadId) {
          // Step 4: Campaign API
          try {
            await fetch(
              "https://campaigns.digitmoney.in/api/offercheck/requestjson.php?case=insert_digit_money_data",
              {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                  api_key: "fca6416db1074658d6b6823380d18f04",
                  mobile: mobile,
                  lead_id: fetchedLeadId,
                }),
              },
            );
          } catch (e) {
            console.error("Error in external lead insert:", e);
          }

          // Step 5: ✅ Lender specific bulk push (Prefr Preapproved)
          if (pre_lender_id === "667ffb7b0dd50ee1bb6556c5") {
            try {
              // ── Check if lender_api_call already exists for this lead ──
              const lenderApiCheckRes = await callApi(
                `v1/lender_api_call/${fetchedLeadId}/get-fail-success-lenders`,
                "post",
                {},
                "loan",
                otpResponse.data.token,
              );

              const successList =
                lenderApiCheckRes?.status === "Success" &&
                Array.isArray(lenderApiCheckRes?.data?.Successlist)
                  ? lenderApiCheckRes.data.Successlist
                  : [];

              const alreadyPushed = successList.some(
                (l) => l.lender_id === "667ffb7b0dd50ee1bb6556c5",
              );

              if (alreadyPushed) {
                // Lender API call already exists → skip bulk push
                console.log("Prefr lender_api_call already exists, skipping bulk push.");
              } else {
                // Lender API call does NOT exist → call bulk-lead-push-by-leadId
                const bulkRes = await callApi(
                  "v1/lead/bulk-lead-push-by-leadId",
                  "post",
                  {
                    leads: [{ lead_id: fetchedLeadId }],
                    lender_name: "Prefr Preapproved",
                    lender_id: "667ffb7b0dd50ee1bb6556c5",
                  },
                  "core",
                  otpResponse.data.token,
                );
                if (bulkRes?.status === "Success") {
                  console.log("Bulk push successful.");
                } else {
                  console.error("Bulk push failed:", bulkRes);
                }
              }
            } catch (err) {
              console.error("Prefr lender check / bulk push error:", err);
            } finally {
              setFormData((prev) => ({ ...prev, fetchedLeadId }));
              setCurrentStep(2);
            }
            return;
          }
        }

        // Normal flow
        setFormData((prev) => ({ ...prev, fetchedLeadId }));
        setCurrentStep(2);
      } else {
        toast.error("Invalid OTP. Please try again.");
      }
    } catch (otpError) {
      console.error("Error occurred while verifying OTP:", otpError);
      //toast.error("An error occurred while verifying OTP. Please try again.");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      {!isOtpGenerated ? (
        // ✅ Mobile input screen
        <div className="lead-capture-container1-kf">
          <div className="relative flex items-center px-2" style={{ marginBottom: '1.1rem' }}>
              <div className="flex-grow border-t border-gray-300"></div>

              <span className="mx-2 text-sm font-medium text-gray-500 whitespace-nowrap">
                Check your loan eligibility instantly
              </span>

              <div className="flex-grow border-t border-gray-300"></div>
            </div>

          <input type="hidden" name="utm_campaign" value="" />
          <input type="hidden" name="utm_source" value={utmSource || ""} />
          <input type="hidden" name="utm_medium" value="" />
          <input type="hidden" name="utm_content" value="" />
          <input type="hidden" name="click_id" value="" />
          <input type="hidden" name="aff_id" value={affId || ""} />
          <input type="hidden" name="src" value={source || ""} />

          <FormInputStyle2
            type="text"
            name="mobile"
            isValid={isMobileValid}
            id="mobile"
            minLength="10"
            maxLength="10"
            pattern="[0-9]{10}"
            value={mobile}
            onChange={handleMobileChange}
            required
            label={"Mobile Number"}
            inputMode="numeric"
            errorMessage={"Please enter a valid Mobile Number"}
            className="mobile-kf"
          />
          <div className="checkbox-wrapper-pf">
            <input
              type="checkbox"
              id="consent"
              checked={isConsentChecked}
              onChange={handleConsentChange}
            />
            <label htmlFor="consent" className="consent">
              I have read and agreed to the{" "}
              <a className="anc-font-pf" href="https://digitmoney.in/terms">
                Terms of Use
              </a>{" "}
              and hereby appoint DigitMoney and its{" "}
              <a className="anc-font-pf" href="https://digitmoney.in/lenders">
                Lending Partners
              </a>{" "}
              to receive my credit information from credit bureaus. By
              submitting my details I override my NDNC registration & authorize
              DigitMoney and its{" "}
              <a className="anc-font-pf" href="https://digitmoney.in/lenders">
                Lending Partners
              </a>{" "}
              / representatives to contact me through Call, SMS, Email, WhatsApp
              or any other mode. I also Authorize you to send me new promotional
              offers of financial & non-financial products or services from time
              to time.
              <br />
              <br />
              You will receive OTP on mobile number
            </label>
          </div>

          <div className="checkbox-wrapper-pf">
            <input
              type="checkbox"
              id="prefr-consent"
              checked={isPrefrConsentChecked}
              onChange={handlePrefrConsentChange}
            />
            <label htmlFor="prefr-consent" className="consent">
              I agree to the{" "}
              <a className="anc-font-pf" href="https://prefr.com/terms_and_conditions">
                T&Cs
              </a>{" "}
              of{" "}
              <a className="anc-font-pf" href="https://prefr.com/bureau_terms_tu">
                TUCIBIL
              </a>{" "}
              and{" "}
              <a className="anc-font-pf" href="https://prefr.com/bureau_terms_crif">
                CRIF Highmark
              </a>{" "}
              ("CIC") and explicitly consent to Prefr fetching my Credit Information
              from all or any of the above CICs and sharing the same with me and using
              it for the purpose agreed under the above T&Cs.
            </label>
          </div>

          <FormButtonStyleCheckOffer
            style={{ backgroundColor: "#12F280" }}
            text="Get OTP"
            onClick={handleSendOtp}
            disabled={!isMobileValid || isLoading}
            id="btn-get-otp-landing-v4"
            className="tracking-btn-get-otp-landing-v4-kf"
          />
        </div>
      ) : (
        // ✅ OTP screen - dead block hata diya, sirf yeh render hoga
        <div className="plv16-otp-page-pf">
          <div className="plv16-otp-hero">
            <img
              src="/assets/img/Layer_1 (47).png"
              className="plv16-otp-lock"
              alt="Lock"
            />
            <h1 className="plv16-otp-title">Verify number securely</h1>
            <p className="plv16-otp-subtitle">
              Your details are safe with us
              <img
                src="/assets/img/Layer_1 (48).png"
                className="plv16-otp-info"
                alt="Secure"
              />
            </p>
          </div>

          <div className="plv16-otp-card-kf">
            <div className="plv16-otp-card-title">
              We can help prefill your information
            </div>

            <div className="plv16-otp-card-subtitle">
              Enter OTP sent to{" "}
              <span className="plv16-otp-phone">
                +91-{mobile || "98616XXXXX"}
              </span>{" "}
              <button
                type="button"
                className="plv16-otp-edit"
                onClick={openEditMobileModal}
              >
                Edit
              </button>
            </div>

            <div className="plv16-otp-input-wrap">
              <OTPInput
                value={otp}
                onChange={(val) => setOtp(val)}
                numInputs={4}
                isInputNum={true}
                shouldAutoFocus={true}
                inputStyle="plv16-otp-input"
                containerStyle="plv16-otp-inputs"
                placeholder={"----"}
                renderInput={(props) => <input {...props} />}
              />
            </div>
          </div>
          <div className="plv16-otp-footer">
            <div className="plv16-otp-resend">
              {canResendOtp ? (
                <button
                  type="button"
                  className="plv16-otp-resend-link"
                  onClick={handleResendOtp}
                  disabled={isLoading}
                >
                  Resend OTP
                </button>
              ) : (
                <>
                  Resend OTP in <span>{formatResendTime(resendCounter)}</span>
                </>
              )}
            </div>

            <button
              type="button"
              className="plv16-otp-btn"
              onClick={handleOtpSubmit}
              disabled={otp.length !== 4 || isLoading}
              id="btn-verify-otp-personal-details-v9"
            >
              {isLoading ? "Processing..." : "Verify OTP"}
            </button>
          </div>

          {/* ✅ Edit Mobile Modal - handleEditMobileSendOtp fix */}
          {isEditMobileModalOpen ? (
            <div
              className="plv16-otp-modal-overlay"
              role="dialog"
              aria-modal="true"
              onClick={closeEditMobileModal}
            >
              <div
                className="plv16-otp-modal"
                onClick={(e) => e.stopPropagation()}
              >
                <div className="plv16-otp-modal-header">
                  <button
                    type="button"
                    className="plv16-otp-modal-close"
                    onClick={closeEditMobileModal}
                    aria-label="Close"
                  >
                    ×
                  </button>
                </div>
                <div className="plv16-otp-modal-title">Edit Mobile Number</div>
                <div className="plv16-otp-modal-subtitle">
                  We'll send a new OTP to this number.
                </div>

                <div className="plv16-otp-modal-body">
                  <input
                    type="tel"
                    inputMode="numeric"
                    placeholder="Enter New Mobile Number"
                    className="plv16-otp-modal-input"
                    value={editMobileValue}
                    onChange={(e) => {
                      const next = e.target.value
                        .replace(/\D/g, "")
                        .slice(0, 10);
                      setEditMobileValue(next);
                      setEditMobileError("");
                    }}
                  />
                  {editMobileError ? (
                    <div className="plv16-otp-modal-error">
                      {editMobileError}
                    </div>
                  ) : null}

                  {/* ✅ handleEditMobileSendOtp - sahi function */}
                  <button
                    type="button"
                    className="plv16-otp-modal-btn"
                    onClick={handleEditMobileSendOtp}
                    disabled={isLoading}
                  >
                    {isLoading ? "Processing..." : "Send OTP"}
                  </button>

                  <div className="plv16-otp-modal-footnote">
                    Make sure this number is active to receive the OTP.
                  </div>
                </div>
              </div>
            </div>
          ) : null}
        </div>
      )}
    </>
  );
};

export default MobileOtpPage;